module.exports = __webpack_public_path__ + "static/media/banner-home.fe07d947.jpg";